import { Entity, ViewAcl } from '@msdk/definitions'

import { ViewCustomActionArgs } from './custom-action-args'
import { CustomActionBase } from './custom-action-base'

export abstract class ViewCustomAction extends CustomActionBase {
  protected readonly reload: () => Promise<void>
  protected selectedRows: Entity[]
  protected readonly api: string
  protected readonly entityName: string
  protected readonly apiRequireClaim: string
  protected acl: ViewAcl | undefined

  constructor(args: ViewCustomActionArgs) {
    super(args)
    this.reload = args.reload
    this.selectedRows = args.selectedRows
    this.api = args.api
    this.entityName = args.entityName
    this.apiRequireClaim = args.apiRequireClaim
    this.acl = args.acl
  }

  public updateSelectedRows(rows: Entity[]) {
    this.selectedRows = rows
  }

  public updateAcl(acl?: ViewAcl) {
    this.acl = acl
  }
}
